module.exports = __webpack_public_path__ + "img/mycard.a1dca470.png";